<template>
	<div class="container-fluid bg-default-color">
		<service-toolbar :show-title-widget="true"></service-toolbar>

		<service-report-summary
			:total-revenue="service.revenueRaw"
			:total-profit="service.grossProfitRaw"
			:total-profit-margin="service.grossProfitMarginRaw"
			:total-permits-cost="service.permitCostRaw"
			:total-equipment-cost="service.equipmentCostRaw"
			:total-labour-cost="service.labourCostRaw"
			:total-material-cost="service.materialCostRaw"
			:total-submitted-expenses="service.submittedExpenseCostRaw"
			:total-service-task-cost="service.totalServiceTaskCostRaw"
			:show-chart="showChart"
			:chart-data="chartData"
			:service-ids="[service.id]">
		</service-report-summary>

	</div>
</template>
<script type="text/javascript">

import ServiceToolbar from "./ServiceToolbar"
import Widget from "@/components/Widget"
import ServiceReportSummary from "@/components/ServiceReportSummary"

import ServiceMixins from "@/mixins/ServiceMixins.js"
import ReportsMixins from "@/mixins/ReportsMixins.js"
	
export default {
	name: "ServiceReport",
	components: {
		ServiceToolbar,
		Widget,
		ServiceReportSummary
	},
	mixins: [ServiceMixins,ReportsMixins],
	data() {
		return {
			service: {},
			collectiveAgreements: [],
			showChart: false,
			chartData: {},
			worksheets: []
		}
	},
	watch: {
		'$store.service'() {

			let vm = this

			if ("TimeLog" in this.$store.service && 'Expense' in this.$store.service)
				this.calcReportSummary()
			else {
				this.fetchData().then(response => {
					vm.calcReportSummary()
				})
			}
		}
	},
	computed: {

	},
	methods: {
		fetchData() {
			let vm = this

			//now fetch time logs and append to service
			let timeLogParams = {
				filters: [
					["service_id",vm.$store.service.id]
				],
				include: [
					{
						model:"User",
						fields:["id","slug"],
						include: [
							{
								model:"EmployeeClassification",
								fields: ["id","slug","title","default_cost_hr","union_id"]
							}
						]
					}
				]
			}

			let expenseParams = {
				filters: [
					['service_id',vm.$store.service.id]
				]
			}

			let promises = [
				vm.getJSON("CollectiveAgreement/get",{include: ["Union"]}),
				vm.getJSON("TimeLog/get",timeLogParams),
				vm.getJSON("Expense/get",expenseParams)
			]
			
			return new Promise((resolve,reject) => {
				Promise.all(promises).then(responses => {
					if (responses[0].success)
						vm.$store.collectiveAgreements = responses[0].data

					if (responses[1].success) 
						vm.$store.service.TimeLog = responses[1].data

					if (responses[2].success)
						vm.$store.service.Expense = responses[2].data

					resolve(responses)
				})
			})
		},
		calcReportSummary() {
			let vm = this

			this.service = this.mutateService(this.$store.service)

			this.chartData = [
				this.service.materialCostRaw.toFixed(2),
				this.service.labourCostRaw.toFixed(2),
				this.service.equipmentCostRaw.toFixed(2),
				this.service.permitCostRaw.toFixed(2),
				this.service.submittedExpenseCostRaw.toFixed(2),
				this.service.grossProfitRaw.toFixed(2)
			]
			this.showChart = true
		}
	},
	created() {
		let vm = this
		let requiredResources = ["Customer","TimeLog","ServiceInvoice","Category","Expense","ServiceWorksheet"]

		this.setServiceIfNotSet(requiredResources).then(service => {

			vm.fetchData().then(responses => {
				vm.calcReportSummary()
			})
		})
	}
}
</script>
